import { ticketStatusLabel } from "@/modules/tickets/ticketInboxConfig";
import { formatDurationShort } from "@/modules/tickets/ticketInboxUi";
import { toneClass } from "@/modules/shared/status";

export const DEFAULT_WAITING_SLA_HOURS = 48;

export const resolveWaitingSlaHours = (hours?: number | null) =>
  hours != null && Number.isFinite(hours) && hours > 0
    ? hours
    : DEFAULT_WAITING_SLA_HOURS;

export const getTicketWaitingDurationLabel = (
  status?: string | null,
  updatedAt?: string | null,
  slaHours: number = DEFAULT_WAITING_SLA_HOURS,
) => {
  if (status !== "waiting" || !updatedAt) return null;
  const updated = new Date(updatedAt);
  if (Number.isNaN(updated.getTime())) return null;

  const hours = (Date.now() - updated.getTime()) / (1000 * 60 * 60);
  if (hours < slaHours) return null;

  const days = Math.floor(hours / 24);
  if (days >= 1) {
    return days === 1 ? "Waiting 1d" : `Waiting ${days}d`;
  }
  return `Waiting ${Math.floor(hours)}h`;
};

export const ticketWaitingSlaClassName = (
  status?: string | null,
  updatedAt?: string | null,
  slaHours: number = DEFAULT_WAITING_SLA_HOURS,
) => {
  if (!getTicketWaitingDurationLabel(status, updatedAt, slaHours)) return "";
  return toneClass("warning", "solid");
};

/** Time spent in the current ticket status (from updated_at). */
export const getTicketStatusDurationLabel = (
  status?: string | null,
  updatedAt?: string | null,
) => {
  if (!status?.trim() || !updatedAt) return null;
  const updated = new Date(updatedAt);
  if (Number.isNaN(updated.getTime())) return null;

  const duration = formatDurationShort(Date.now() - updated.getTime());
  if (!duration) return null;

  const statusName = ticketStatusLabel(status.trim());
  const title =
    statusName.charAt(0).toUpperCase() + statusName.slice(1).toLowerCase();
  return `${title} · ${duration}`;
};

export const ticketStatusDurationClassName = (
  status?: string | null,
  updatedAt?: string | null,
  slaHours: number = DEFAULT_WAITING_SLA_HOURS,
) => {
  if (!getTicketStatusDurationLabel(status, updatedAt)) return "";
  if (status === "waiting") {
    return getTicketWaitingDurationLabel(status, updatedAt, slaHours)
      ? toneClass("warning", "solid")
      : toneClass("muted", "solid");
  }
  if (status === "resolved") {
    return toneClass("success", "solid");
  }
  return toneClass("muted", "solid");
};
